import axios from "axios";
import { returnAutoMotionSlideArray } from "@/utils/autoSpacedUtils";
import { db } from "@/fstore";

const returnPublishedData = (show_object, rootState) => {
  var slideArray = show_object.data.slideArray.map(item => {
    delete item.id;
    // Blank out the movement data for json files.
    item.end_percent_scale = 100;
    item.end_percent_x = 0;
    item.end_percent_y = 0;
    item.start_percent_scale = 100;
    item.start_percent_x = 0;
    item.start_percent_y = 0;
    item.has_motion = false;
    return item;
  });
  if (slideArray.length === 0) {
    // No slideArray, construct one.
    var aspectRatio = show_object.data.displaySettings.aspectRatio || 3 / 2;
    slideArray = returnAutoMotionSlideArray(show_object, aspectRatio);
  }
  var publishData = {
    slideArray: slideArray,
    audioFile: show_object.data.audio,
    key: show_object.key,
    publishedAt: new Date().getTime(),
    title: show_object.title,
    overlayArray: show_object.data.overlayArray,
    displaySettings: show_object.data.displaySettings,
    imageSizes: rootState.imageSizes,
    formatVersion: 3
  };
  return publishData;
};

const returnPrivateData = show_object => {
  var publishData = {
    published: false,
    formatVersion: 3,
    privacySelected: show_object.privacySelected || "private"
  };
  return publishData;
};

const writeDataToFile = (key, publishData, show_object, callback) => {
  // Put data into a file blob.
  var fileObj = new Blob([JSON.stringify(publishData)], {
    type: "application/json"
  });

  let formData = new FormData();
  var fields = show_object.jsonCredentialsV4.fields;
  for (const [key, value] of Object.entries(fields)) {
    // Don't add key, we want the slug as the name.
    if (key != "key") {
      formData.append(key, value);
    }
  }
  formData.append("key", key); // Necessary as fields key includes ${filename}
  formData.append("acl", "public-read");
  formData.append("success_action_status", "201");
  formData.append("Content-Type", "application/json");
  formData.append("Cache-Control", "no-cache");
  formData.append("file", fileObj);

  axios
    .post(
      `https://${show_object.jsonCredentialsV4.bucket}.s3.amazonaws.com/`,
      formData,
      {
        onUploadProgress: progressEvent => {
          console.log(progressEvent);
          var _uploaded = Math.ceil(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          console.log(_uploaded);
          console.log(`https://cdn3.soundslides.com/${key}`);
        }
      }
    )
    .then(function(e) {
      console.log(e);
      console.log("SUCCESS!!");
      if (callback) {
        callback();
      }
    });
};

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    publishJson({ dispatch }, show_object) {
      console.log(show_object);
      if (show_object.privacyState === "private") {
        // No json, no private json.
        dispatch("writeEmptyJson", show_object);
        dispatch("writeEmptyPrivateLinkJson", show_object);
      }
      if (show_object.privacyState === "world") {
        // public json, no private json.
        dispatch("writeWorldJson", show_object);
        dispatch("writeEmptyPrivateLinkJson", show_object);
      }
      if (show_object.privacyState === "privateLink") {
        // public json, no private json.
        dispatch("writeEmptyJson", show_object);
        dispatch("writePrivateLinkJson", show_object);
      }
      if (show_object.privacyState === "password") {
        dispatch("writeEmptyJson", show_object);
        dispatch("writeEmptyPrivateLinkJson", show_object);
        dispatch("writePasswordJson", show_object);
      }
    },
    publishShowByKey({ dispatch }, show_key) {
      // This is the safest option considering all the write update issues.
      // Mainly partial updates to Firestore.
      var showRef = db.collection("editor_shows").doc(show_key);
      showRef
        .get()
        .then(function(doc) {
          if (doc.exists) {
            console.log("Document data:", doc.data());
            var updatedShowDoc = doc.data();
            dispatch("publishJson", updatedShowDoc);
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function(error) {
          console.log("Error getting document:", error);
        });
    },
    writeWorldJson({ rootState }, show_object) {
      console.log("writeWorldJson");
      // Define all published data for the json file.
      var publishData = returnPublishedData(show_object, rootState);
      var key = "json/" + show_object.key + "/data.json";
      var callback = () => {
        // Open in new window.
        //window.open(
        //  `https://play.soundslides.com/${show_object.key}`,
        //  "_blank"
        //);
        // Record state no longer publishing.
        rootState.publishingInProgress = false;
      };
      writeDataToFile(key, publishData, show_object, callback);
    },
    writePrivateLinkJson({ rootState }, show_object) {
      console.log("writePrivateLinkJson");
      // Define all published data for the json file.
      var publishData = returnPublishedData(show_object, rootState);
      var key =
        "json/" +
        show_object.key +
        "/" +
        show_object.privateLinkKey +
        "/" +
        "data.json";
      var callback = () => {
        // Record state no longer publishing.
        rootState.publishingInProgress = false;
      };
      writeDataToFile(key, publishData, show_object, callback);
    },
    writePasswordJson({ rootState }, show_object) {
      console.log("writePasswordJson");
      var publishData = returnPublishedData(show_object, rootState);
      var key =
        "json/" +
        show_object.key +
        "/" +
        show_object.privateLinkKey +
        "/" +
        show_object.passwordFileKey +
        "/data.json";
      var callback = () => {
        // Record state no longer publishing.
        rootState.publishingInProgress = false;
      };
      writeDataToFile(key, publishData, show_object, callback);
    },
    writeEmptyJson({ rootState }, show_object) {
      console.log("writeEmptyJson");
      console.log(rootState);
      // Define all published data for the json file.
      var publishData = returnPrivateData(show_object);
      var key = "json/" + show_object.key + "/data.json";
      var callback = () => {
        // Open in new window.
        rootState.publishingInProgress = false;
      };
      writeDataToFile(key, publishData, show_object, callback);
    },
    writeEmptyPrivateLinkJson({ rootState }, show_object) {
      console.log("writeEmptyPrivateLinkJson");
      console.log(rootState);
      // Define all published data for the json file.
      var publishData = returnPrivateData(show_object);
      var key =
        "json/" +
        show_object.key +
        "/" +
        show_object.privateLinkKey +
        "/" +
        "data.json";
      var callback = () => {
        // Record state no longer publishing.
        rootState.publishingInProgress = false;
      };
      writeDataToFile(key, publishData, show_object, callback);
    }
  }
};
